import { MutableRefObject, useEffect, useMemo, useState } from 'react';

/**
 * Adapted from https://stackoverflow.com/a/65008608/13088941
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 */

const useIntersection = (ref: MutableRefObject<any>) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const handleThresholdTrigger: IntersectionObserverCallback = ([entry]) => setIntersecting(entry.isIntersecting);

  const observer = useMemo(() => new IntersectionObserver(handleThresholdTrigger), []);

  useEffect(() => {
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [ref, observer]);

  return isIntersecting;
};

export default useIntersection;
